import { useEffect, useState } from "react";
import { Loader2, Trash2, Mail, Phone, User, Inbox } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { toast } from "sonner";
import api from "@/lib/api";
import { formatDate } from "@/lib/format";
import { useSeo } from "@/hooks/useSeo";

const AdminKontak = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteId, setDeleteId] = useState(null);
  useSeo("Pesan Masuk");

  const load = () => {
    setLoading(true);
    api.get("/contacts").then((r) => setItems(r.data)).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const confirmDelete = async () => {
    try { await api.delete(`/contacts/${deleteId}`); toast.success("Pesan dihapus"); load(); }
    catch { toast.error("Gagal menghapus"); }
    finally { setDeleteId(null); }
  };

  return (
    <div>
      <h1 className="font-heading text-2xl font-bold text-slate-900">Pesan Masuk</h1>
      <p className="mt-1 text-sm text-slate-500">Pesan dari formulir kontak website.</p>

      <div className="mt-6">
        {loading ? (
          <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-emerald-600" /></div>
        ) : items.length === 0 ? (
          <div className="rounded-2xl border border-dashed border-slate-300 bg-white py-16 text-center text-slate-400" data-testid="admin-contacts-empty">
            <Inbox className="mx-auto h-10 w-10 opacity-40" />
            <p className="mt-3">Belum ada pesan masuk.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {items.map((c) => (
              <div key={c.id} className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" data-testid={`admin-contact-${c.id}`}>
                <div className="flex items-start justify-between gap-4">
                  <div className="min-w-0">
                    <p className="flex items-center gap-2 font-medium text-slate-800"><User className="h-4 w-4 text-emerald-600" />{c.name}</p>
                    <div className="mt-1 flex flex-wrap gap-4 text-sm text-slate-500">
                      <span className="flex items-center gap-1"><Mail className="h-3.5 w-3.5" />{c.email}</span>
                      {c.phone && <span className="flex items-center gap-1"><Phone className="h-3.5 w-3.5" />{c.phone}</span>}
                    </div>
                  </div>
                  <div className="flex shrink-0 items-center gap-3">
                    <span className="text-xs text-slate-400">{formatDate(c.created_at)}</span>
                    <Button size="icon" variant="outline" onClick={() => setDeleteId(c.id)} data-testid={`admin-contact-delete-${c.id}`} className="h-9 w-9 border-red-100 text-red-500 hover:bg-red-50"><Trash2 className="h-4 w-4" /></Button>
                  </div>
                </div>
                <p className="mt-3 rounded-lg bg-slate-50 p-3 text-sm text-slate-600">{c.message}</p>
              </div>
            ))}
          </div>
        )}
      </div>

      <AlertDialog open={!!deleteId} onOpenChange={() => setDeleteId(null)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Hapus pesan ini?</AlertDialogTitle>
            <AlertDialogDescription>Pesan akan dihapus permanen.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Batal</AlertDialogCancel>
            <AlertDialogAction onClick={confirmDelete} className="bg-red-600 hover:bg-red-700" data-testid="admin-contact-confirm-delete">Hapus</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default AdminKontak;
